module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('br'), _vm._v(" "), (_vm.administrador === false && ((_vm.projeto.funcao != null && _vm.projeto.funcao.item === 1 && _vm.projeto.situacao.item === 18) || (_vm.projeto.assessor === true && _vm.projeto.situacao.item === 18))) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "center"
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', {
    staticClass: "black--text font-weight-bold"
  }, [_vm._v("\n                Como a ação de extensão está na situação \"Ativo\", é possível alterar apenas os campos \"Objetivos específicos\" e \"Informações adicionais\".\n              ")])], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [(_vm.administrador === true) ? _c('v-select', {
    attrs: {
      "items": _vm.listaUnidades,
      "eager": "",
      "item-text": "nomeSigla",
      "item-value": "id",
      "label": "Unidade",
      "return-object": "",
      "autocomplete": "",
      "required": ""
    },
    model: {
      value: (_vm.extensao.unidade),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "unidade", $$v)
      },
      expression: "extensao.unidade"
    }
  }) : _c('v-select', {
    attrs: {
      "items": _vm.listaUnidades,
      "item-text": "nomeSigla",
      "item-value": "id",
      "label": "Unidade",
      "return-object": "",
      "readonly": "",
      "autocomplete": "",
      "required": "",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.unidade),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "unidade", $$v)
      },
      expression: "extensao.unidade"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaCoordenadoPor,
      "item-text": "descricao",
      "item-value": "item",
      "return-object": "",
      "label": "Coordenado por",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.coordenadoPor),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "coordenadoPor", $$v)
      },
      expression: "extensao.coordenadoPor"
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaTipoEvento,
      "item-text": "descricao",
      "item-value": "item",
      "return-object": "",
      "label": "Tipo de Evento",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.tipoEvento),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "tipoEvento", $$v)
      },
      expression: "extensao.tipoEvento"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data da primeira apresentação",
      "type": "date",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.dtPrimeiraApresentacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "dtPrimeiraApresentacao", $$v)
      },
      expression: "extensao.dtPrimeiraApresentacao"
    }
  })], 1)], 1), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.itensCampoEmpresaJunior,
      "item-text": "descricao",
      "item-value": "item",
      "label": "O programa é uma Empresa Júnior?",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.empresaJunior),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "empresaJunior", $$v)
      },
      expression: "extensao.empresaJunior"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projeto.classificacaoSecundaria.id === 39733) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-alert', {
    staticClass: "alerta",
    attrs: {
      "color": "#00796b",
      "type": "info",
      "dense": "",
      "outlined": ""
    }
  }, [_vm._v("\n            Conforme os Artigos 03, 06 e 10 da Resolução nº.10/2019 do Conselho Universitário, as empresas juniores deverão ser cadastradas na Pró-Reitoria de Extensão – PROEX como Programa de Extensão.\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "label": "Apresentação",
      "rules": _vm.AreaDeTextoRules2000,
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.apresentacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "apresentacao", $$v)
      },
      expression: "extensao.apresentacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000",
      "label": "Justificativa / Mérito extensionista",
      "rules": _vm.AreaDeTextoRules2000,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.justificativa),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "justificativa", $$v)
      },
      expression: "extensao.justificativa"
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('div', _vm._g({}, on), [_c('c-textarea', _vm._g({
          attrs: {
            "rows": 2,
            "auto-grow": true,
            "multi-line": "",
            "counter": "500",
            "label": "Caracterização do público-alvo",
            "rules": _vm.AreaDeTextoRules500,
            "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
          },
          model: {
            value: (_vm.extensao.caracterizacaoPublicoAlvo),
            callback: function($$v) {
              _vm.$set(_vm.extensao, "caracterizacaoPublicoAlvo", $$v)
            },
            expression: "extensao.caracterizacaoPublicoAlvo"
          }
        }, on))], 1)]
      }
    }], null, false, 3992814955)
  }, [_vm._v(" "), _c('span', [_c('div', [_vm._v("As atividades de extensão devem envolver diretamente as comunidades externas às instituições de ensino superior e estarem vinculadas à formação do estudante (Resolução CNE 07/2018, Art. 7°).")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.extensao.caracterizacaoPublicoAlvo && _vm.projeto.tipoPublico.item === 1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', _vm._g({
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "500",
      "label": "Caracterização do público-alvo interno (membros da comunidade acadêmica)",
      "rules": _vm.AreaDeTextoRules500,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.publicoAlvoInterno),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "publicoAlvoInterno", $$v)
      },
      expression: "extensao.publicoAlvoInterno"
    }
  }, _vm.on))], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.extensao.caracterizacaoPublicoAlvo) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', _vm._g({
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "500",
      "label": "Caracterização do público-alvo externo (membros da sociedade)",
      "rules": _vm.AreaDeTextoRules500,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.publicoAlvoExterno),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "publicoAlvoExterno", $$v)
      },
      expression: "extensao.publicoAlvoExterno"
    }
  }, _vm.on))], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "500",
      "label": "Objetivo geral",
      "rules": _vm.AreaDeTextoRules500,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.objetivosGerais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "objetivosGerais", $$v)
      },
      expression: "extensao.objetivosGerais"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "id": "label"
    }
  }, [_vm._v("Objetivos específicos (Liste os objetivos separadamente em tópicos. Para abrir um novo tópico, clique no ícone +)")]), _vm._v(" "), _c('v-list', {
    staticClass: "label",
    attrs: {
      "id": "label",
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((_vm.objetivosEspecificosTopicos), function(item, index) {
    return _c('v-list-item', {
      key: item.id,
      staticStyle: {
        "padding": "0px"
      }
    }, [_c('v-list-item-avatar', [_vm._v("\n                " + _vm._s(index + 1) + ".\n              ")]), _vm._v(" "), _c('v-list-item-content', [_c('v-text-field', {
      attrs: {
        "auto-grow": true,
        "placeholder": "Digite o objetivo específico",
        "rules": _vm.AreaDeTextoRulesN1000
      },
      model: {
        value: (item.nome),
        callback: function($$v) {
          _vm.$set(item, "nome", $$v)
        },
        expression: "item.nome"
      }
    })], 1), _vm._v(" "), (_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1)) ? _c('v-list-item-action', [_c('c-tooltip-btn', {
      attrs: {
        "icon": "remove_circle",
        "color": "red",
        "tooltip": "Adicionar objetivo específico"
      },
      on: {
        "click": function($event) {
          return _vm.objetivosEspecificosTopicos.splice(index, 1)
        }
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-list-item', {
    staticStyle: {
      "padding": "0px"
    }
  }, [(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1)) ? _c('v-list-item-action', [_c('c-tooltip-btn', {
    attrs: {
      "icon": "add_box",
      "color": "green",
      "tooltip": "Adicionar objetivo específico"
    },
    on: {
      "click": function($event) {
        return _vm.objetivosEspecificosTopicos.push({
          nome: ''
        })
      }
    }
  })], 1) : _vm._e()], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "3000",
      "label": "Metodologia",
      "rules": _vm.AreaDeTextoRules3000,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.metodologia),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "metodologia", $$v)
      },
      expression: "extensao.metodologia"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.extensao.curso || _vm.extensao.oficina) ? _c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Formas de avaliação dos cursistas (descrever os meios avaliativos, o peso das avaliações e a frequência mínima para a aprovação dos cursistas)",
      "rules": _vm.AreaDeTextoRules1000,
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.formaAvaliacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "formaAvaliacao", $$v)
      },
      expression: "extensao.formaAvaliacao"
    }
  }) : _c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Forma de avaliação",
      "rules": _vm.AreaDeTextoRules1000,
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.formaAvaliacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "formaAvaliacao", $$v)
      },
      expression: "extensao.formaAvaliacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Infraestrutura física",
      "rules": _vm.AreaDeTextoRules1000,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.infraestruturaFisica),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "infraestruturaFisica", $$v)
      },
      expression: "extensao.infraestruturaFisica"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "rows": 2,
      "auto-grow": true,
      "multi-line": "",
      "counter": "1000",
      "label": "Informações adicionais",
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1))
    },
    model: {
      value: (_vm.extensao.informacoesAdicionais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "informacoesAdicionais", $$v)
      },
      expression: "extensao.informacoesAdicionais"
    }
  })], 1)], 1), _vm._v(" "), (_vm.extensao.prestacaoServico) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.listaTiposPrestacaoServico,
      "chips": "",
      "label": "Tipo de Prestação de Serviço",
      "multiple": ""
    },
    model: {
      value: (_vm.listaTiposPrestacaoServicoSelecionados),
      callback: function($$v) {
        _vm.listaTiposPrestacaoServicoSelecionados = $$v
      },
      expression: "listaTiposPrestacaoServicoSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento ao público em espaços de cultura, ciência e tecnologia")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus Culturais"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus Culturais")])]
      },
      proxy: true
    }], null, false, 1352582964),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Espaços e Museus de Ciência e Tecnologia"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Espaços e Museus de Ciência e Tecnologia")])]
      },
      proxy: true
    }], null, false, 820644792),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Cines-clube"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Cines-clube")])]
      },
      proxy: true
    }], null, false, 2587689909),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento ao público em espaços de cultura, ciência e tecnologia')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "Outros"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.listaAtendimentoPublicoEspacosSelecionados),
      callback: function($$v) {
        _vm.listaAtendimentoPublicoEspacosSelecionados = $$v
      },
      expression: "listaAtendimentoPublicoEspacosSelecionados"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Serviço eventual")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de assessorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numAssessorias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numAssessorias", $$v)
      },
      expression: "extensao.numAssessorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de consultorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numConsultorias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numConsultorias", $$v)
      },
      expression: "extensao.numConsultorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de curadorias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numCuradorias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numCuradorias", $$v)
      },
      expression: "extensao.numCuradorias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Serviço eventual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de outros",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numOutrosServicos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numOutrosServicos", $$v)
      },
      expression: "extensao.numOutrosServicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atividades de propriedade intelectual")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de depósito de patentes e modelos de utilidades",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numPatentesModelos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numPatentesModelos", $$v)
      },
      expression: "extensao.numPatentesModelos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de registro de marcas e softwares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numMarcasSoftwares),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numMarcasSoftwares", $$v)
      },
      expression: "extensao.numMarcasSoftwares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de contratos de transferência de tecnologia",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numTransferenciaTecnologia),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numTransferenciaTecnologia", $$v)
      },
      expression: "extensao.numTransferenciaTecnologia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atividades de propriedade intelectual')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de registros de direitos autorais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numDireitosAutorais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numDireitosAutorais", $$v)
      },
      expression: "extensao.numDireitosAutorais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Exames e laudos técnicos')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Exames e laudos técnicos")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de laudos emitidos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numLaudosEmitidos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numLaudosEmitidos", $$v)
      },
      expression: "extensao.numLaudosEmitidos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento jurídico')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento jurídico")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numAtendimentosJuridicos),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numAtendimentosJuridicos", $$v)
      },
      expression: "extensao.numAtendimentosJuridicos"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde humana")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de consultas ambulatoriais (programadas)",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numConsultasAmbulatoriais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numConsultasAmbulatoriais", $$v)
      },
      expression: "extensao.numConsultasAmbulatoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de consultas de emergência e urgência",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numConsultasEmergencia),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numConsultasEmergencia", $$v)
      },
      expression: "extensao.numConsultasEmergencia"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de internações",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numInternacoes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numInternacoes", $$v)
      },
      expression: "extensao.numInternacoes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de cirurgias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numCirurgias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numCirurgias", $$v)
      },
      expression: "extensao.numCirurgias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de exames laboratoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numExamesLaboratoriais),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numExamesLaboratoriais", $$v)
      },
      expression: "extensao.numExamesLaboratoriais"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de exames complementares",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numExamesComplementares),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numExamesComplementares", $$v)
      },
      expression: "extensao.numExamesComplementares"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde humana')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de outros atendimentos",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numOutrosAtendimentosSH),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numOutrosAtendimentosSH", $$v)
      },
      expression: "extensao.numOutrosAtendimentosSH"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('p', {
    staticClass: "tipoPrestacaoServico"
  }, [_vm._v("Tipo: Atendimento em saúde animal")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nº de atendimentos veterinários ambulatoriais",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numAtendimentosVeterinarios),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numAtendimentosVeterinarios", $$v)
      },
      expression: "extensao.numAtendimentosVeterinarios"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de internações veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numInternacoesVeterinarias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numInternacoesVeterinarias", $$v)
      },
      expression: "extensao.numInternacoesVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de cirurgias veterinárias",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numCirurgiasVeterinarias),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numCirurgiasVeterinarias", $$v)
      },
      expression: "extensao.numCirurgiasVeterinarias"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.prestacaoServico && _vm.listaTiposPrestacaoServicoSelecionados.includes('Atendimento em saúde animal')) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº de exames laboratoriais e complementares em veterinária",
      "rules": _vm.campoNumericoRules
    },
    model: {
      value: (_vm.extensao.numExamesVeterinaria),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "numExamesVeterinaria", $$v)
      },
      expression: "extensao.numExamesVeterinaria"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui vínculo com ensino",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.vinculoEnsino),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "vinculoEnsino", $$v)
      },
      expression: "extensao.vinculoEnsino"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui vínculo com pesquisa",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.vinculoPesquisa),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "vinculoPesquisa", $$v)
      },
      expression: "extensao.vinculoPesquisa"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Esta ação realiza divulgação científica",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.divulgacaoCientifica),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "divulgacaoCientifica", $$v)
      },
      expression: "extensao.divulgacaoCientifica"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Esta é uma ação direcionada às escolas públicas (alunos, professores, servidores ou processo de formação continuada)",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.direcionadaEscolaPublica),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "direcionadaEscolaPublica", $$v)
      },
      expression: "extensao.direcionadaEscolaPublica"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Esta ação será utilizada para a creditação da extensão nos cursos de graduação da UFES",
      "disabled": !(_vm.administrador === true || (_vm.projeto.funcao !== null && _vm.projeto.funcao.item === 1 && _vm.projeto.situacao.item === 15))
    },
    model: {
      value: (_vm.extensao.creditacaoGraduacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "creditacaoGraduacao", $$v)
      },
      expression: "extensao.creditacaoGraduacao"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Data inicial da creditação",
      "type": "date",
      "disabled": !_vm.extensao.creditacaoGraduacao
    },
    model: {
      value: (_vm.extensao.dtInicialCreditacao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "dtInicialCreditacao", $$v)
      },
      expression: "extensao.dtInicialCreditacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Envolve captação de recursos financeiros ou bens duráveis",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.captacaoRecursosBensDuraveis),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosBensDuraveis", $$v)
      },
      expression: "extensao.captacaoRecursosBensDuraveis"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Por meio de:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 566531570),
    model: {
      value: (_vm.extensao.captacaoRecursosUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosUfes", $$v)
      },
      expression: "extensao.captacaoRecursosUfes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("CAPES")])]
      },
      proxy: true
    }], null, false, 433251667),
    model: {
      value: (_vm.extensao.captacaoRecursosCapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCapes", $$v)
      },
      expression: "extensao.captacaoRecursosCapes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Fundação de apoio")])]
      },
      proxy: true
    }], null, false, 3770891229),
    model: {
      value: (_vm.extensao.captacaoRecursosFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFest", $$v)
      },
      expression: "extensao.captacaoRecursosFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("CNPq")])]
      },
      proxy: true
    }], null, false, 623129403),
    model: {
      value: (_vm.extensao.captacaoRecursosCnpq),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosCnpq", $$v)
      },
      expression: "extensao.captacaoRecursosCnpq"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("FAPES")])]
      },
      proxy: true
    }], null, false, 300731254),
    model: {
      value: (_vm.extensao.captacaoRecursosFapes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosFapes", $$v)
      },
      expression: "extensao.captacaoRecursosFapes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.extensao.captacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "captacaoRecursosOutros", $$v)
      },
      expression: "extensao.captacaoRecursosOutros"
    }
  })], 1), _vm._v(" "), (_vm.extensao.captacaoRecursosBensDuraveis === true) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": _vm.extensao.captacaoRecursosOutros !== true || (_vm.administrador !== true && _vm.projeto.situacao.item !== 15),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.extensao.especCaptacaoRecursosOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especCaptacaoRecursosOutros", $$v)
      },
      expression: "extensao.especCaptacaoRecursosOutros"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Envolve liberação de carga horária do coordenador aprovada em Departamento/Centro/Setor de lotação",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.liberacaoCargaHoraria),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "liberacaoCargaHoraria", $$v)
      },
      expression: "extensao.liberacaoCargaHoraria"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.extensao.liberacaoCargaHoraria === true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rows": 1,
      "label": "Carga horária aprovada",
      "rules": _vm.CargaHorariaCoordenadorAprovadaRules,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.cargaHorariaCoordenadorAprovada),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "cargaHorariaCoordenadorAprovada", $$v)
      },
      expression: "extensao.cargaHorariaCoordenadorAprovada"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina || _vm.extensao.evento) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Gratuito para o público",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.gratuito),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuito", $$v)
      },
      expression: "extensao.gratuito"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Os recursos financeiros obtidos serão administrados por:")])])], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("UFES")])]
      },
      proxy: true
    }], null, false, 566531570),
    model: {
      value: (_vm.extensao.gratuitoUfes),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoUfes", $$v)
      },
      expression: "extensao.gratuitoUfes"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("FEST")])]
      },
      proxy: true
    }], null, false, 1159691731),
    model: {
      value: (_vm.extensao.gratuitoFest),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFest", $$v)
      },
      expression: "extensao.gratuitoFest"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("FUCAM")])]
      },
      proxy: true
    }], null, false, 2822406859),
    model: {
      value: (_vm.extensao.gratuitoFucam),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoFucam", $$v)
      },
      expression: "extensao.gratuitoFucam"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [(_vm.extensao.gratuito === false) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', [_vm._v("Outros")])]
      },
      proxy: true
    }], null, false, 900719639),
    model: {
      value: (_vm.extensao.gratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "gratuitoOutros", $$v)
      },
      expression: "extensao.gratuitoOutros"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.gratuito === false) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm5": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "disabled": _vm.extensao.gratuitoOutros !== true || (_vm.administrador !== true && _vm.projeto.situacao.item !== 15),
      "label": "Especifique:",
      "rows": "1",
      "auto-grow": "",
      "counter": "200",
      "rules": _vm.rules200,
      "placeholder": " "
    },
    model: {
      value: (_vm.extensao.especGratuitoOutros),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "especGratuitoOutros", $$v)
      },
      expression: "extensao.especGratuitoOutros"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Modalidade",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.modalidade),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "modalidade", $$v)
      },
      expression: "extensao.modalidade"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Presencial",
      "value": "P"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Semipresencial",
      "value": "S"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "EAD",
      "value": "D"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Utiliza o AVA Extensão",
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.utilizaAvaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "utilizaAvaExtensao", $$v)
      },
      expression: "extensao.utilizaAvaExtensao"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.extensao.curso || _vm.extensao.oficina) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Em caso de utilização de outro Ambiente Virtual de Aprendizagem (AVA), indique a plataforma",
      "counter": "100",
      "rules": _vm.AreaDeTextoRules100,
      "disabled": _vm.administrador !== true && _vm.projeto.situacao.item !== 15
    },
    model: {
      value: (_vm.extensao.plataforma),
      callback: function($$v) {
        _vm.$set(_vm.extensao, "plataforma", $$v)
      },
      expression: "extensao.plataforma"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarExtensao(false)
      }
    }
  }, [_vm._v("Salvar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarExtensao(true)
      }
    }
  }, [_vm._v("Salvar e Avançar")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffb0bcb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/editar-projeto/editar-extensao.vue
// module id = 526
// module chunks = 0